import React, { useEffect, useState } from 'react';
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import './common/Styles.css'
import DebugService from '../services/DebugService';
import SnackbarNotification, { SNACKBAR_THEME } from './common/SnackbarNotification';
import ConnectionApiService from '../services/ConnectionApiService';
import { useAuth } from '../state/AuthContext';
import { CONST_SITE_LABEL, STORAGE_KEYS, setScopedItem } from './common/Helper';

/**
 * Devops Monitoring Component
 * @returns 
 */
export const DevopsMonitoring = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(null)
  const [snackbarStatus, setSnackbarStatus] = useState(null)
  const [scanResult, setScanResult] = useState([])
  const [selectedItem, setSelectedItem] = useState('')
  const [devopsMonitoringApiData, setDevopsMonitoringApiData] = useState([])

  const { selectedAccount } = useAuth()

  /**
 * Select Item handler
 * @param {*} pointerEvent 
 */
  const selectItemHandler = (pointerEvent) => {
    DebugService.log(`Devops Monitoring Component: Selected item`, pointerEvent)
    setSelectedItem(pointerEvent['target']['value'])
  }

  const fetchData = () => {
    setSelectedItem('')

    ConnectionApiService.getMonitoringList(selectedAccount)
      .then(data => {
        DebugService.log(`Devops Monitoring Component: Monitoring Data`, data)
        setDevopsMonitoringApiData(data)

        if (data['data']) {
          setScanResult(data['data'] ?? [])

          // Select first result by default
          if (data['data'].length > 0) {
            setSelectedItem(data['data'][0])
          }
        }

        if (data['error']) {
          setSnackbarStatus('failed')
          setSnackbarMessage(data['error'])
        }

        setIsLoading(false)
      })
      .catch(err => {
        DebugService.error(`Devops Monitoring Component: Failed to fetch data`, err)
        setSnackbarStatus('failed')
        setSnackbarMessage('Something went wrong while fetching data')
        setIsLoading(false)
      })
  }

  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | Devops Monitoring`

    setSnackbarStatus(null)
    setSnackbarMessage(null)
    setIsLoading(false)
    fetchData()
  }, [])

  useEffect(() => {
    fetchData()
  }, [selectedAccount])

  /**
  * @description Stores the latest API response in storage.
  * @author Ashish Sharma
  */
  useEffect(() => {
      setScopedItem(STORAGE_KEYS.AI_CHATBOT_REQUEST_DATA,devopsMonitoringApiData)
  },[devopsMonitoringApiData])
  
  return (
    <Grid container spacing={1} className='monitoring-page'>
      <Grid item xs={12} md={6}>
        {/* Select item  */}
        <FormControl size='small' fullWidth>
          <InputLabel id="item-select-label">Select</InputLabel>
          <Select
            labelId='item-select-label'
            value={selectedItem}
            label="Result"
            onChange={selectItemHandler}
          >
            {scanResult.length > 0 && scanResult.map(d => (
              <MenuItem key={d['accountMonitoringId']} value={d}>{d['monitoringName']}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        {selectedItem && <iframe
          title={selectedItem['monitoringName']}
          src={selectedItem['monitoringUrl']}
          width="100%"
          className='frame-height'
          // height="100%"
          frameBorder="0" />
        }
      </Grid>

      {/* Snackbar Notification */}
      {snackbarStatus && <SnackbarNotification
        initialOpen={true}
        duration={5000}
        message={snackbarMessage}
        actionButtonName={'Ok'}
        theme={snackbarStatus === 'success' ? SNACKBAR_THEME.GREEN : SNACKBAR_THEME.RED}
        yPosition={'top'}
        xPosition={'center'}
      />}
    </Grid>
  )
}
